export default __webpack_public_path__ + "static/10-mouth-watering-destinations-for-unashamed-foodies-new-york-730b86345673e005347c5c2a7e87c4fc.jpg";